import getDefaultOpts from "@/store/utils/getDefaultOpts.js";
import useTwitter from "@/util/useTwitter.ts";
import { useApiStore } from "@/stores/api/index.ts";

const { formatUsername } = useTwitter();

/*
For some home buttons, like Twitter and Calendar, we only want to fetch data once the user has finished typing. This is to avoid making unnecessary requests to the API.
Once the user clicks "Ready!", this action will trigger a /confirm{buttonType} API request, which will attempt to fetch data.
If the data is successfully fetched, the backend will set the "confirmed" property to true.
The /tweets endpoint will then use this property to determine whether to fetch tweets.
 */
async function confirmHomeButtonData(module, { value, buttonId, opts = {} }) {
  const api = useApiStore();
  const { dispatch, rootGetters, commit } = module;
  const config = Object.assign(getDefaultOpts(), opts);
  const buttonType = value.type;
  const username = value.data.url;
  if (buttonType !== "Twitter" || !username) {
    return Promise.resolve();
  }
  // Remove '@' symbol from username or extract username from URL
  const formattedUsername = formatUsername(username);
  try {
    const res = await dispatch("httpRequest", {
      func: api.confirmTwitter(formattedUsername, buttonId),
      config,
    });
    if (res?.data?.confirmed) {
      await dispatch("fetchTweets", {
        formattedUsername,
        buttonId,
        opts,
      });
    }
    const homeButtons = rootGetters.getStoreVar(
      "Home",
      "styling",
      "homeButtons",
      "homeButtons"
    );
    const index = homeButtons.findIndex(
      (button) => button.buttonId === buttonId
    );
    homeButtons[index].data.confirmed = res?.data?.confirmed;
    await dispatch(
      "setStoreVar",
      {
        page: "Home",
        group: "styling",
        type: "homeButtons",
        name: "homeButtons",
        value: homeButtons,
      },
      { root: true }
    );
    return "Success!";
  } catch (error) {
    commit("storeTwitterFeed", { buttonId, tweets: [] }); // clear tweets array
    return "Error confirming username";
  }
}

export { confirmHomeButtonData };
